import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AmenityDashboardPage" */
	'pages/vehicle/Amenity/AmenityDashboardPage'));

export default [{ component, exact: true, path: '/amenities/:amenityId' }];